import React from "react";

const JQuery_Selectors = () => {
  return (
    <div>
      <h1>JQuery_Selectors</h1>
      <p>Placeholder component for: "JQuery_Selectors"</p>
    </div>
  );
};

export default JQuery_Selectors;
